module.exports = __webpack_public_path__ + "img/4.dc5d7a2b.png";